export default __webpack_public_path__ + "1a97c573632ab3847ff8144e7fef2123.png";